module.exports = __webpack_public_path__ + "img/data-processing.44be0720.svg";